import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../../_lib/ViewFetcher';
import { AccessLevelData } from '../../common/types';
import { AccessLevelInfoRequestForm, AccessLevelInfoRequestFormTypes }
  from '../../common/forms/AccessLevelInfoRequestForm';

type ChangeAccessLevelEditViewProps = {
  pendingRequest?: AccessLevelData;
  editPendingRequestForm?: AccessLevelInfoRequestFormTypes;
};

function ChangeAccessLevelEdit({ editPendingRequestForm, pendingRequest }: ChangeAccessLevelEditViewProps) {
  if (pendingRequest && editPendingRequestForm) {
    return (
      <AccessLevelInfoRequestForm form={editPendingRequestForm} />
    );
  }

  return null;
}

export const ChangeAccessLevelEditView = asFetchableView(ChangeAccessLevelEdit);
export type ChangeAccessLevelEditView = ComponentProps<typeof ChangeAccessLevelEditView>;
